import world from "../Static Files/Images/HomePage/active tours/World 32x32.png";
import ArrowIcon from "./arrowIcon";
import "../Static Files/styles/sidebar/sidebar.css";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const TopNav = () => {
  const { userInfo } = useSelector((state) => state.users);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo) {
      navigate("/login");
    }
    if(localStorage.getItem("token") === null){
      navigate("/login");
    }
  }, [userInfo, navigate]);

  return (
    <>
      <div className="admin-navbar">
        <input className="search" type="text" placeholder="Search" />
        <ul>
          <li>
            <img src={world} alt="user" />
            <h4>{userInfo?.email}</h4>
          </li>
          <li>
            <Link onClick={()=>localStorage.removeItem("token")} to="/login" className="logout-button">
              Çıxış edin
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default TopNav;
